const Supplier = "Supplier";
const Subsidiary = "Subsidiary";
const Affliate = "Affliate";
const PartnerShip_JV = "PartnerShip/JV";
const Franchises = "Franchises";
const Independent = "Independent";
const Equity_Share = "Equity Share";
const Operational_Control = "Operational Control";
const Financial_Control = "Financial Control";
export const ValueChainCalculationMethods = [Supplier, Subsidiary, Affliate, PartnerShip_JV, Franchises, Independent];

export const OrganizationCalculationMethods = [Equity_Share, Operational_Control, Financial_Control];

export const ValueChain = "Value Chain";
export const Organization = "Organization";
